import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_PROJECT_AC_CENTRAL',
  CREATE: 'ADD_PROJECT_AC_CENTRAL',
  DELETE: 'DELETE_PROJECT_AC_CENTRAL',
  CLEAR_ERROR: 'CLEAR_ERROR_PROJECT',
};

export const listACCentralInBuilding = (pageSize, page, sorted, filtered, isPublic, buildingId) => {
  return {
    type: ACTION.LIST,
    payload: RestClient.request({
      method: 'get',
      url: Constants.API_PROJECT_AC_CENTRAL,
      params: {
        search: filtered,
        limit: pageSize,
        offset: pageSize * page,
        ordering: sorted
          ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
          : null,
        is_public: isPublic,
        building_id: buildingId,
      }
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const addACCentralToBuilding = (acCentralId, buildingId, quantity) => {
  const data = {
    ac_central_id: acCentralId,
    building_id: buildingId,
    quantity: quantity,
  };

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_PROJECT_AC_CENTRAL,
      data,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const removeACCentralFromBuilding = (projectACCentralId, buildingId) => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_PROJECT_AC_CENTRAL}${projectACCentralId}/`,
    })
      .then(() => ({ id: projectACCentralId, building_id: buildingId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};


// WEBPACK FOOTER //
// ./src/redux/projects/project_ac_central_actions.js